<template>
  <div class="home-box">
    <PageTitle title="Create Tax" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-col cols="12" class="home-tabs-body">
        <TaxCreateForm />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TaxCreateForm from "@/components/taxes/TaxCreateForm.vue";
import PageTitle from "@/components/shared/PageTitle";

export default {
  name: "CreateTax",
  components: { TaxCreateForm, PageTitle },
  computed: {
    vuexloading() {
      return false; // Just for testing, should show the form now
    },
  },
};
</script>
